import AppDebugger from './AppDebugger';
import React from 'react';
import { createRoot } from 'react-dom/client';

console.log('NODE_ENV:', process.env.NODE_ENV);
if (process.env.NODE_ENV === "production") {
  console.log = () => {};
  console.debug = () => {};
  console.info = () => {};
  console.warn = () => {};
  console.error = () => {};
}

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <AppDebugger />
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
/* serviceWorkerRegistration.unregister(); */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
/* reportWebVitals(); */

